import { DependenciesPayload } from '@sxm-de/dev-kits/web-sdk/types';
import {
    logErrorFromClientSdk,
    trackBusinessError,
} from '@sxm-de/dev-kits/web-sdk/utils';

export interface ActivateUserCodePayload {
    activationCode: string;
    vendor?: 'sonos';
}

export async function activateUserCode(
    { activationCode, vendor }: ActivateUserCodePayload,
    dependencies: DependenciesPayload,
): Promise<void> {
    const { clientSdk, appEventSdk } = dependencies;
    try {
        vendor && vendor === 'sonos'
            ? await clientSdk.user.linkCodeAuthorize(activationCode)
            : await clientSdk.user.userCodeAuthorize(activationCode);
    } catch (error: any) {
        if (
            error.code ===
                'tokenServicesTeam.sessionService.invalid-user-code' ||
            error.code === 'tokenServicesTeam.sessionService.invalid-link-code'
        ) {
            trackBusinessError(appEventSdk, error);
            throw new Error('INVALID_ACTIVATION_CODE');
        } else {
            logErrorFromClientSdk(error, dependencies);
            throw new Error('SYSTEM');
        }
    }
}
